import { useState } from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  {
    question: 'In welchen Gebieten führt IGM Facility Service Projekte durch?',
    answer:
      'Wir sind hauptsächlich in Ratingen und der gesamten Region NRW tätig – darunter Düsseldorf, Mettmann, Erkrath, Hilden, Langenfeld, Velbert und weitere Städte. Bei größeren Bauprojekten fahren wir auch darüber hinaus. Sprechen Sie uns einfach an!',
  },
  {
    question: 'Was versteht man unter GalaBau und welche Leistungen sind enthalten?',
    answer:
      'GalaBau steht für Garten- und Landschaftsbau und umfasst alle Arbeiten rund um die Gestaltung und Anlage von Außenbereichen: Wege und Terrassen pflastern, Grünflächen anlegen, Hecken und Bepflanzungen setzen, Teiche bauen und Zäune errichten. Wir planen und realisieren Ihren Garten von der ersten Idee bis zur Fertigstellung.',
  },
  {
    question: 'Wie läuft ein Bauprojekt mit IGM Facility Service ab?',
    answer:
      'Nach Ihrer Anfrage vereinbaren wir einen kostenlosen Vor-Ort-Termin, besprechen Ihre Wünsche und erstellen ein transparentes Festpreisangebot. Nach Auftragserteilung übernehmen wir die komplette Koordination und Bauleitung. Sie erhalten regelmäßige Statusupdates bis zur Schlüsselübergabe.',
  },
  {
    question: 'Arbeiten Sie mit Festpreisen oder nach Aufwand?',
    answer:
      'Wir arbeiten grundsätzlich mit transparenten Festpreisangeboten. So haben Sie von Anfang an Kostensicherheit und müssen keine bösen Überraschungen befürchten. Eventuelle Zusatzkosten durch unvorhergesehene Leistungen werden vorab mit Ihnen besprochen und schriftlich festgehalten.',
  },
  {
    question: 'Was beinhalten Bauzeichnungen für Garten und Landschaften?',
    answer:
      'Unsere Bauzeichnungen für Garten- und Landschaftsprojekte umfassen maßstabsgenaue Lagepläne, Bepflanzungspläne, Höhenpläne sowie Detailzeichnungen für Wege, Terrassen und Wasserflächen. Diese Pläne dienen als verbindliche Grundlage für die Ausführung und können ggf. auch für Baugenehmigungen eingereicht werden.',
  },
  {
    question: 'Wie lange dauert eine typische Wohnungssanierung?',
    answer:
      'Das hängt stark vom Umfang ab. Eine Bad-Komplettsanierung dauert in der Regel 1–3 Wochen. Eine Wohnungsvollsanierung (ca. 80 qm) ist meist in 4–8 Wochen abgeschlossen. Bei der Projektplanung legen wir einen verbindlichen Zeitplan fest.',
  },
  {
    question: 'Bieten Sie auch Einzelgewerke an oder nur Komplettlösungen?',
    answer:
      'Beides! Sie können gezielt einzelne Leistungen beauftragen – z. B. nur Malerarbeiten oder Fliesenverlegung – oder uns als Generalunternehmer für Ihr Gesamtprojekt einsetzen. Wir sind flexibel und passen uns Ihren Bedürfnissen an.',
  },
  {
    question: 'Welche Garantien erhalten wir auf die ausgeführten Arbeiten?',
    answer:
      'Alle unsere Bauleistungen unterliegen den gesetzlichen Gewährleistungsfristen (5 Jahre für Bauleistungen nach BGB §634a). Darüber hinaus bieten wir für bestimmte Bereiche erweiterte Herstellergarantien auf verwendete Materialien.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="py-16 sm:py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center gap-2 bg-[#0D2B4E]/5 rounded-full px-5 py-2 mb-5">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-question-answer-line text-[#0D2B4E] text-lg" />
            </div>
            <span className="text-sm font-semibold text-[#0D2B4E] tracking-wide">
              Häufige Fragen
            </span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Häufig gestellte Fragen
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
            Antworten auf die wichtigsten Fragen rund um unsere Bau- und
            Sanierungsleistungen in Ratingen und NRW.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className={`rounded-xl border transition-all duration-300 overflow-hidden ${
                openIndex === idx
                  ? 'border-[#0D2B4E]/30 bg-white'
                  : 'border-gray-200 bg-white hover:border-[#0D2B4E]/20 hover:shadow-sm'
              }`}
            >
              <button
                className="w-full flex items-center justify-between gap-4 px-5 sm:px-7 py-4 sm:py-5 text-left cursor-pointer"
                aria-expanded={openIndex === idx}
                onClick={() => toggle(idx)}
              >
                <h4 className="text-sm sm:text-base font-semibold text-gray-900 leading-snug">
                  {faq.question}
                </h4>
                <div
                  className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${
                    openIndex === idx
                      ? 'bg-[#0D2B4E] text-white rotate-180'
                      : 'bg-gray-100 text-gray-500'
                  }`}
                >
                  <i className="ri-arrow-down-s-line text-lg" />
                </div>
              </button>
              <div
                style={{ maxHeight: openIndex === idx ? '400px' : '0' }}
                className="transition-all duration-300 ease-in-out overflow-hidden"
              >
                <p className="px-5 sm:px-7 pb-5 sm:pb-6 text-sm sm:text-base text-gray-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10 sm:mt-14">
          <p className="text-gray-500 text-sm mb-4">Noch weitere Fragen?</p>
          <Link
            to="/kontakt"
            className="inline-flex items-center gap-2 bg-[#0D2B4E] text-white px-7 py-3.5 rounded-lg font-semibold hover:bg-[#0a2240] transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-mail-send-line text-lg" />
            </div>
            <span>Direkt anfragen</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
